module.exports = __webpack_public_path__ + "fb333ccb4083df09b1e15f321980eafb.pdf";